import { _wxLogin } from '../api/index';


export default function wxLogin(isWechatBrowser, userStore) {

    if (!isWechatBrowser) {
        return;
    }

    let openid = localStorage.getItem('openid');
    if (openid === null || openid === undefined || openid === '') {
        console.log('未获取到openid')
        return;
    }

    _wxLogin({ openid: openid }).then((res) => {
        if (res.data.message === 'ok') {
            // 登录成功
            userStore.setInfo(
                res.data.data.access_token,
                res.data.data.nickname,
                res.data.data.id,
                res.data.data.imgurl
            );
        }
    }).catch((err) => {
        console.log(err);
    });
}